import { Teaser as t } from '@xprog/prensa/types'

export const TeaserVideoTop: t.TeaserProps = {
  css: {
    backgroundColor: 'transparent',
    mb: '$8',
    '.TeaserImageContainer': {
      mb: '$3'
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      color: '#FFFFFF !important',
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      color: '#f5f5f5',
      my: '$0'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '25px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%'
    },
    padding: '$0',
    width: '100%'
  },
  className: 'TeaserImageTop',
  imageDerivative: '2x1',
  imageVariant: 'top',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
}
